var PetcoDataLayer ={};
var product={};
function pushEvent(eventJson,elementId) {
	try{
        if($('#omnitureEnabled').length > 0 && $('#omnitureEnabled').val() != '') {    
            var omnitureEnabledVal =  $('#omnitureEnabled').val();
			if(omnitureEnabledVal == 'true'){
		        var event;
		        if(typeof eventJson == "object"){
		        	event = eventJson;
		        }
		        else{
		        	event = JSON.parse(eventJson);		        	
		        }	
		        if(undefined != elementId && null !=elementId ){
                    getAttrValue(event,document.getElementById(elementId));
                }
		        PetcoDataLayer["events"]=event;
		        var eventName = event["event_name"];		        
		        if(null != event && typeof utag != undefined){
		            utag.link({'event_name' : eventName });
		        }
		    }
		}
	}catch(err){		
		 console.log("Error occured while linking the event"+ err);	
		 return true;
	}
}
function omnitureTagging(elementId){
	try{
        if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {    
            var omnitureEnabledVal =  $('#omnitureEnabled').val();
			if(omnitureEnabledVal == 'true'){
			var objId = elementId ;	             
	       	if(null != $("#"+objId).attr("data-info") || undefined != $("#"+objId).attr("data-info")){
	            var eventJson=$("#"+objId).attr("data-info");
	            pushEvent(eventJson);  
	        }                         
	    }
		}		
	}catch(err){
		 console.log("Error occured while linking the event from funtion omnitureTagging"+ err);
		 return true;
	}

	}
function trackEventStart(eventName){
	try{
        if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {    
            var omnitureEnabledVal =  $('#omnitureEnabled').val();
			if(omnitureEnabledVal == 'true'){
		        var eventStatus ={"event_status" : "start","event_name" : eventName};  
	    		pushEvent(eventStatus);
			}
		}	       
	  }catch(err){
		 console.log("Error occured while linking the event from funtion trackEventStart"+ err);
		 return true;
	}
  }
function buildProductDataLayerVariable(productJson) {
	try {

		if (null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			var omnitureEnabledVal = $('#omnitureEnabled').val();
			if (omnitureEnabledVal == 'true') {


								if (null != productJson && undefined != productJson) {
					var product_sku_array = new Array();
					product_sku_array.push(productJson.catalogEntryIdentifier.externalIdentifier.partNumber);
					product["product_sku"] = product_sku_array;
					var productname_array = new Array();
					var productName = productJson.description[0].name;
					productName = productName.replace(/,/g, "");
					productname_array.push(productName);
					product["product_name"] = productname_array;
					var listPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD',  minimumFractionDigits: 2 }).format(productJson.listPrice); 
					var offerPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD',  minimumFractionDigits: 2 }).format(productJson.offerPrice);
					if (!productJson.listPriced || listPrice <= offerPrice) {
						var teliumPrice = productJson.offerPrice;
						var telium_Price = teliumPrice.replace('\$', '');

												var product_price_array = new Array();
						product_price_array.push(telium_Price.replace(',', ''));
						product["product_price"] = product_price_array;

												var product_list_price_array = new Array();
						product_list_price_array.push(telium_Price);
						product["product_list_price"] = product_list_price_array;
					} else {
						var teliumPrice = productJson.offerPrice;
						var telium_Price = teliumPrice.replace('\$', '');	

												var product_price_array = new Array();
						product_price_array.push(telium_Price.replace(',', ''));
						product["product_price"] = product_price_array;

						var teliumPrice_l = productJson.listPrice;
						var telium_Price_l = teliumPrice_l.replace('\$', '');
						if (teliumPrice_l.length > 0) {
							var product_list_price_array = new Array();
							product_list_price_array.push(telium_Price_l);
							product["product_list_price"] = product_list_price_array;
						} else {
							var product_list_price_array = new Array();
							product_list_price_array.push(telium_Price);
							product["product_list_price"] = product_list_price_array;
						}
					}
					var product_array = new Array();
					product_array.push(productJson.catalogEntryIdentifier.uniqueID);
					product["product_id"] = product_array;
				}

								if ($('#attributeRatings').size()>0){
					var product_array = new Array();
					var ratings = $('#attributeRatings').val();
					if (ratings != ''){
						if (ratings.indexOf("[")!= -1){
							ratings=ratings.replace('[','');
							ratings=ratings.replace(']','');
						}
						var ratingCount = ratings.split(",");
						var rCount;						
						null!=ratingCount[0] && !ratingCount[0].length == 0 ?rCount =parseFloat(ratingCount[0]).toFixed(1) : rCount='0';
						product_array.push(rCount);
						product["product_rating"] = product_array;
					}
				}
				if ($('#attributeRatingsCount').size()>0 ){
					var product_array = new Array();
					var attrRtCount=$('#attributeRatingsCount').val();					
					attrRtCount == '' || attrRtCount.length === 0 ?product_array.push('0') : product_array.push(attrRtCount);
					product["product_reviews"] = product_array;
				}

								if (product) {
					PetcoDataLayer.product = product;
							try{
								var pdtJSONObj = {};
								pdtJSONObj["event_name"] = "product_view";
								pdtJSONObj["product_id"]= productJson.catalogEntryIdentifier.uniqueID;
								pdtJSONObj["partNumber"]= productJson.catalogEntryIdentifier.externalIdentifier.partNumber;
								pdtJSONObj["name"]= productJson.description[0].name;
								if($('#tel_product_id').size()>0){
									pdtJSONObj["product_parent_sku"] = $('#tel_product_id').val();
								}
								pdtJSONObj["eventStatus"] = "end";
								if (document.readyState === 'complete') {
									pushEvent(pdtJSONObj);
								}

															}
							catch(err){
								console.log(err);
								return true;
							}

										}
			}
		}
	} catch (err) {
		console.log("buildProductDataLayerVariable" + err);
		return true;
	}

}

function buildAddonProductDataLayerVariable() {
	try {
		if (null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			var omnitureEnabledVal = $('#omnitureEnabled').val();
			if (omnitureEnabledVal == 'true') {				
				var addToRD;
				var addon = "no";
				if ($('#selectRDOrderBtnAddTo:visible').size()>0){
					addToRD = "recurring";
					addon = "yes";
				}

				if ($('#rd-add-on:visible').size()>0 || $('#selectRDOrderBtnCpy:visible').size()>0){
					if(addToRD) {
						addToRD = "both";
					} else {
						addToRD = "once";
					}
					addon = "yes";
				}

								if (addToRD){
					product["add_to_rd"] = addToRD;
				}
				product["addon"] = addon;

				if (product) {
					PetcoDataLayer.product = product;
				}
			}
		}
	} catch (err) {
		console.log("buildAddonProductDataLayerVariable" + err);
		return true;
	}

}

function buildRDProductDataLayerVariable(subscriptionId) {
	try {

		if (null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			var omnitureEnabledVal = $('#omnitureEnabled').val();
			if (omnitureEnabledVal == 'true') {


								if (null != subscriptionId && undefined != subscriptionId) {
					var product_sku_array = new Array();
					if($('#tel_product_sku_'+subscriptionId) && $('#tel_product_sku_'+subscriptionId).val() != "") {
						product_sku_array.push($('#tel_product_sku_'+subscriptionId).val());
						product["product_sku"] = product_sku_array;
					}

										var productname_array = new Array();
					if($('#tel_product_name_'+subscriptionId) && $('#tel_product_name_'+subscriptionId).val() != "") {
						var productName = $('#tel_product_name_'+subscriptionId).val();
						productName = productName.replace(/,/g, "");
						productname_array.push(productName);
						product["product_name"] = productname_array;
					}

					var listPrice;
					if($('#tel_product_list_price_'+subscriptionId) && $('#tel_product_list_price_'+subscriptionId).val() != "") {
						listPrice = parseFloat($('#tel_product_list_price_'+subscriptionId).val());
					}

										var offerPrice;
					if($('#tel_product_price_'+subscriptionId) && $('#tel_product_price_'+subscriptionId).val() != "") {
						offerPrice = parseFloat($('#tel_product_price_'+subscriptionId).val());
					}

										if (!listPrice || listPrice <= offerPrice) {
						var product_price_array = new Array();
						product_price_array.push(offerPrice);
						product["product_price"] = product_price_array;

												var product_list_price_array = new Array();
						product_list_price_array.push(offerPrice);
						product["product_list_price"] = product_list_price_array;
					} else {
						var product_price_array = new Array();
						product_price_array.push(offerPrice);
						product["product_price"] = product_price_array;

												if (listPrice > 0) {
							var product_list_price_array = new Array();
							product_list_price_array.push(listPrice);
							product["product_list_price"] = product_list_price_array;
						} else {
							var product_list_price_array = new Array();
							product_list_price_array.push(offerPrice);
							product["product_list_price"] = product_list_price_array;
						}
					}
					var product_array = new Array();
					if($('#tel_product_id_'+subscriptionId) && $('#tel_product_id_'+subscriptionId).val() != "") {
						product_array.push($('#tel_product_id_'+subscriptionId).val());
						product["product_id"] = product_array;
					}

										var product_brand_array = new Array();
					if($('#tel_product_brand_'+subscriptionId) && $('#tel_product_brand_'+subscriptionId).val() != "") {
						product_brand_array.push($('#tel_product_brand_'+subscriptionId).val());
						product["product_brand"] = product_brand_array;
					}

										var product_image_url_array = new Array();
					if($('#tel_product_image_url_'+subscriptionId) && $('#tel_product_image_url_'+subscriptionId).val() != "") {
						product_image_url_array.push($('#tel_product_image_url_'+subscriptionId).val());
						product["product_image_url"] = product_image_url_array;
					}

										var product_parent_id_array = new Array();
					if($('#tel_product_parent_id_'+subscriptionId) && $('#tel_product_parent_id_'+subscriptionId).val() != "") {
						product_parent_id_array.push($('#tel_product_parent_id_'+subscriptionId).val());
						product["product_parent_id"] = product_parent_id_array;
					}
				}

								if (product) {
					PetcoDataLayer.product = product;
				}
			}
		}
	} catch (err) {
		console.log("buildRDProductDataLayerVariable" + err);
		return true;
	}

}

function buildProductInventoryDataLayer(inventoryResponse,inventoryCheck) {
	try {

		if (null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			var omnitureEnabledVal = $('#omnitureEnabled').val();
			if (omnitureEnabledVal == 'true') {
				if(inventoryResponse != null){
					if(PetcoDataLayer.product != null){
						var product_oos = new Array();
						var status;
						if(inventoryCheck == 'onChange'){
							status=inventoryResponse;
						}else{
							status =  inventoryResponse[PetcoDataLayer.product.product_id].onlineInventory_status;
						}
							if(status != 'In-Stock'){
								product_oos.push("yes");
							}else{
								product_oos.push("no");
							}
							PetcoDataLayer.product["product_oos"] = product_oos;
						}

											}
				}

								}
	}catch (err) {
		console.log("buildProductInventoryDataLayer" + err);
		return true;
	}
}

function buildBopusProductInventoryDataLayer(alertLevel,ideintifier) {
	try {

		if (null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {

						var omnitureEnabledVal = $('#omnitureEnabled').val();

						if (omnitureEnabledVal == 'true') {

									if (PetcoDataLayer.product != null) {

												var bopus_oos = new Array();

												if(alertLevel == 'RED'){
								bopus_oos.push("yes");	
							} else {
								bopus_oos.push("no");
							}
							PetcoDataLayer.product["bopus_oos"] = bopus_oos;
							if(typeof(ideintifier) != 'undefined' && ideintifier != null){
								PetcoDataLayer.product["bopus_store"] = ideintifier;
							}
						}

										}

								}
	}catch (err) {
		console.log("buildBopusProductInventoryDataLayer" + err);
		return true;
	}
}

function updateRDProductAddonDataLayer() {
	try {
		if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			var omnitureEnabledVal = $('#omnitureEnabled').val();
			if(omnitureEnabledVal == 'true') {
				if (PetcoDataLayer.product != null && $('#addToRDDropDown').length) {
					if($('#addToRDDropDown').val() == "ADDON") {
						PetcoDataLayer.product["addon"] = "yes";
					} else {
						PetcoDataLayer.product["addon"] = "no";
					}
				}
			}
		}
	}catch (err) {
		console.log("updateRDProductAddonDataLayer " + err);
		return true;
	}
}

function updateSearchData(element, value,link) {
	try {

		if (null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			var omnitureEnabledVal = $('#omnitureEnabled').val();
			if (omnitureEnabledVal == 'true') {
				if(!PetcoDataLayer.search){
				var search = {};	
				PetcoDataLayer["search"]=search;
				} 
				var selectedfilter="";
				if(element == 'search_filter'){
					if(value.indexOf("averagerating")  == 0 ){
						selectedfilter = value;
					}else{					
						selectedfilter = $("#facetLabel_" + value).html().trim() ;
					}
				}	
				else{
					 selectedfilter=value;
				}


												var filterSearch ;
						if(PetcoDataLayer.search && PetcoDataLayer.search.search_filters){
					            var existingValue = PetcoDataLayer.search.search_filters;
					            filterSearch = existingValue +','+ selectedfilter;
							}else{
								 filterSearch = selectedfilter;
							}					       
							PetcoDataLayer.search["search_filters"] = filterSearch;

												var searchEventDetails = {};
						searchEventDetails["search_filters"] = selectedfilter;
						searchEventDetails["event_search_filter"] = "yes";
						searchEventDetails["event_name"] = "search_filter_applied";						
						getAttrValue(searchEventDetails,link);
						pushEvent(searchEventDetails);

											}
			}

			} catch (err) {
		console.log("updateSearchData" + err);
		return true;
	}
}

function checkoutEvents(eventName,element){
		try{	
			var conversion_action_type ='';
			var	conversion_catergory_id ='';
			var	conversion_event_id = '';

						if ($('#orderId') != undefined || $('#orderId').val() != '')				
			var orderId= $('#orderId').val();

						if(eventName == "checkout_guest") {
		    	conversion_action_type = "2";
		    	conversion_catergory_id = "Guest Checkout";
		    	conversion_event_id = "Guest Checkout";
			}else if (eventName =="checkout_sign_in"){
		    	conversion_action_type = "1";
		    	conversion_catergory_id = "SignIn";
		    	conversion_event_id = "SignIn";
			}else{

		    				}
			var eJSONObj = {
					"event_name" : eventName,
					"cart_id" : orderId		,			
					"conversion_action_type" :conversion_action_type,
					"conversion_catergory_id" :conversion_catergory_id,
					"conversion_event_id" : conversion_event_id
					};
			if(element != undefined){
				getAttrValue(eJSONObj,element);	
			}
			pushEvent(eJSONObj);
		}catch(e){
			return true;
		}

		}	

function userEvents(eventName,element){
	try{		
		var eJSON= {};		
		switch(eventName)
		{
		case 'user_log_out' : eJSON["user_state"] = "logged_out";
							  eJSON["event_name"] =eventName;
		break;
		case 'forgot_pw': eJSON["event_name"] ="forgot_pw";
		break;
		case 'user_log_in' : 	eJSON["user_state"] = "logged_in" ;
								eJSON["conversion_action_type"] = "1";
								eJSON["conversion_catergory_id"] = "SignIn";
								eJSON["conversion_event_id"] = "Sign In";
								eJSON["event_name"] =eventName;
		break;
		case 'checkout_start' : if ($('#currentOrderId') != undefined || $('#currentOrderId').val() != '')				
								var orderId= $('#currentOrderId').val() != undefined ?$('#currentOrderId').val() : $('#currentOrderIdShop').val() != undefined ?$('#currentOrderId').val():'';
								if(orderId==""){ orderId = $('#orderIdForPurcList').val() != undefined ?$('#orderIdForPurcList').val() : orderId ;}
								if(orderId==""){ orderId = $('#orderId').val() != undefined ?$('#orderId').val() : orderId ;}
								eJSON["cart_id"] = orderId;
								eJSON["event_name"] =eventName;
		break;	
		default : eJSON["event_name"] =eventName ;
		}
		if(element != undefined){
			getAttrValue(eJSON,element);	
		}		
		pushEvent(eJSON);
	}catch(e){
		return true;
	}
}

function addPromoCodeDetails(promoCode,source){
	try{

		if(source=='cart'){			
			PetcoDataLayer.cart["order_promo_code"] = promoCode;}
		else {
			if(typeof(order) == "undefined"){
				var order ={};
				order["order_promo_code"] = promoCode
			}
			PetcoDataLayer["order"] = order ;
		}
	}catch(e){
		return true;
	}
}
function getAttrValue(eventJSON,element){
try{

	    var linkName = "";	
    if(null != $(element) && undefined != $(element)){		       
        if(undefined !=$(element).attr("manual_cm_sp")){			       
        	linkName = $(element).attr("manual_cm_sp");
        	eventJSON["event_link_type"] ="standard";
        }else if (undefined !=$(element).attr("promo_onsite_link")){
        	linkName = $(element).attr("promo_onsite_link");
        	eventJSON["event_link_type"] ="promo";
        }
        eventJSON["event_link_name"] = linkName;
        eventJSON["event_link_action"] ="click";

				return eventJSON;

		    }
	}catch(e){
		return true;
	}
}
function clickTrackLink(element){
	try{
        if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {    
            var omnitureEnabledVal =  $('#omnitureEnabled').val();
			if(omnitureEnabledVal == 'true'){
				var event ={};
				event=getAttrValue(event,element);
				PetcoDataLayer["events"]=event;
		        if(null != event){
		            utag.link({"event_name" : "link_tracking"});
		        }
		    }
		}
	}catch(err){		
		 console.log("Error occured while linking the event"+ err);	
		 return true;
	}
}
function facetEvents(facetName){
	try{
	var eJSON = {
			"event_search_filter" : "remove",  
			"event_name" : "search_filter_removed", 
			"search_filters" : facetName } ;
		pushEvent(eJSON);
	           if(PetcoDataLayer.search && PetcoDataLayer.search.search_filters){
			            var existingValue = PetcoDataLayer.search.search_filters;

			            			            			            			            var  updatedData=existingValue.replace(','+facetName,"");
			                 updatedData=updatedData.replace(facetName+',',"");
			                 updatedData=updatedData.replace(facetName,"");


			                 			                 						"" == updatedData ? delete PetcoDataLayer.search.search_filters : PetcoDataLayer.search["search_filters"] = updatedData;						
				}			       

						}catch(e){
		return true;
	}

	}

function buildModalDataLayer(name,action,actionDetail) {
	try {

		if (null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			var omnitureEnabledVal = $('#omnitureEnabled').val();

						if (omnitureEnabledVal == 'true') {
				var modal = {};
				modal.name = name;
				modal.action = action;
				if(actionDetail) {
					modal.action_detail = actionDetail;
				} else {
					modal.action_detail = action;
				}
				if("modal_add_to_order" == action && ($('[name=subscriptionId]:checked').length || $('[name=subscriptionId]').length)) {
					var subId;
					if($('[name=subscriptionId]:checked').length) {
						subId = $('[name=subscriptionId]:checked').val();
					} else {
						subId = $('[name=subscriptionId]').val();
					}
					var nextDate = $('#rdOrderNextDate_'+subId).val();
					var freq = "one time";
					if($('#addToRDDropDown').length && $('#addToRDDropDown').val() == 'INC') {
						freq = $('#rdOrderFrequency_'+subId).val();
					}
					if(subId) {
						modal.order_id  = subId;
					}
					if(nextDate) {
						modal.next_order_date = nextDate;
					}
					if(freq) {
						modal.order_frequency = freq;
					}
				}
				if (modal) {
					PetcoDataLayer.modal = modal;
				}
				buildTestDataLayer("AT_PDP_ADDTORDMODAL","addrecurring");
			}
		}
	}catch (err) {
		console.log("buildModalDataLayer" + err);
		return true;
	}
}

function buildModalCloseDataLayer(e,name,linkName) {
	try {

		if (null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			var omnitureEnabledVal = $('#omnitureEnabled').val();

						if (omnitureEnabledVal == 'true') {
				if(e.target !== e.currentTarget) {return;}
				buildModalDataLayer(name,'modal_close_outside_modal');
				var event ={};
				event["event_link_type"] ="standard";
				event["event_link_name"] = linkName;
				event["event_link_action"] ="click";
				PetcoDataLayer["events"]=event;
		        if(null != event){
		            utag.link({"event_name" : "link_tracking"});
		        }
			}
		}
	}catch (err) {
		console.log("buildModalCloseDataLayer" + err);
		return true;
	}
}

function buildTestDataLayer(testName,testId) {
	try {
		var testGroup = sessionStorage.getItem(testName);
		var testFlow = testGroup ? testGroup : "var_A";
		var testExposed = {};
		testExposed.name = testName;
		testExposed.test_audience = testFlow;
		if(!(typeof PetcoDataLayer.testExposed === 'object' && PetcoDataLayer.testExposed !== null)) {
			PetcoDataLayer.testExposed = {};
		}
		PetcoDataLayer.testExposed[testId] = testExposed;
	}catch (err) {
		console.log("buildTestDataLayer" + err);
		return true;
	}
}

function calculateTimePeriod(date2){
    try{
          var one_day=1000*60*60*24;
          var date1_ms = Date.now();
          var strToDate = new Date(date2);
          var date2_ms = strToDate.getTime();
          var difference_ms = date1_ms - date2_ms  ;
          var days= Math.round(difference_ms/one_day);
          var week = days/7;
          var day_cart_open;
                if (week <= 1){
                	if(days<=1){
                		day_cart_open = days+" Day";
                	} else {
                		day_cart_open = days+" Days";
                	}
                }    
                else if(week > 1 && week <= 2)
                    day_cart_open = "1-2 Weeks";
                else if(week > 2 && week <= 3)
                         day_cart_open = "2-3 Weeks";
                      else if(week > 3 && week <= 4)
                         day_cart_open = "3-4 Weeks";
                      else if(days >= 30 && days < 60)
                         day_cart_open= "1 Month";
                      else if(days >= 60 && days < 90)
                         day_cart_open = "2 Month";
                      else if(days >= 90)
                         day_cart_open = "3 Months+ ";
                  return day_cart_open;
              }
               catch (consumeErr) {
                 console.log(consumeErr.message);
                 return 0;

              }

}
function formEvents(eventName,formName,error){
	try{		
		var eJSON= {};		
		switch(eventName)
		{
		case 'form_start' : eJSON["form_name"] = formName;
							eJSON["event_name"] =eventName;
		break;
		case 'form_error': eJSON["event_name"] =eventName;
						   eJSON["form_name"] = formName;
						   eJSON["form_error"] = error;
		break;		
		default : eJSON["event_name"] =eventName ;
		}				
		pushEvent(eJSON);
	}catch(e){
		return true;
	}
}

function readAndFireTeliumTagForReg(){
	var newvalue = "";
	var jsontobeexecuted = {};
	jsontobeexecuted["conversion_event_id"] = "Register";
	jsontobeexecuted["event_name"] = "registration";	
	jsontobeexecuted["conversion_category_id"] = "Register";
	jsontobeexecuted["conversion_action_type"] = "1";	
	for(var i in global_data_for_user_reg){
		var id = i.split("|_|")[0];
		var name = i.split("|_|")[1];
		if(name != ""){
			var newvaluearr = $('#'+id+'[name="'+name+'"]');
			if(newvaluearr.length > 0){
				newvalue = $('#'+id+'[name="'+name+'"]')[0].value;
			}		
		}else{
			var newvaluearr = $('#'+id);
			if(newvaluearr.length > 0){ 
				newvalue = $('#'+id)[0].value;
			}
		}
		if(newvalue != ""){
			if(tagtofire == "customer_name" && typeof(jsontobeexecuted["customer_name"]) != "undefined"){
				newvalue = jsontobeexecuted["customer_name"] +" "+newvalue;
			}
			if(tagtofire == "customer_pals_number" && typeof(jsontobeexecuted["customer_pals_number"]) != "undefined"){
				jsontobeexecuted["pals_account"] ="added";
			}
			else
			{
				jsontobeexecuted["pals_account"] ="created";
			}
			var tagtofire = parentGroupJson_telium[i];
			jsontobeexecuted[tagtofire] = newvalue;
			newvalue = "";
		}
	}
pushEvent(jsontobeexecuted,'WC_UserRegistrationAddForm_links_1');
}

$(document).ready(function() {
	var tel_user_info = getCookie('pcustData');
	var firstName = getCookie('pfirstname');	
	var userType= getCookie('WC_UserType');
	var customerId = getCookie("WC_UserId");
	var flagNo = new Array();
	flagNo.push("No");
	var flagDiscount = new Array();
	flagDiscount.push("0.00");
	var tel_customer_status	="guest";
	if(userType != 'G'){
		if (document.getElementById("firstName") != null && firstName != undefined && firstName != 'undefined') {
			document.getElementById("firstName").innerHTML = '&nbsp;'+ firstName;
		}else {		
			if(document.getElementById('hdr-welcome')!=null)
				document.getElementById('hdr-welcome').style.display = 'none';
		}
	tel_customer_status ="logged in";
	}	
	if(firstName==null || firstName== undefined)
		firstName ="";
	var tel_customer_firstName = '';
	var tel_customer_lastName = '';
	var tel_customer_email = '';
	var tel_customer_city = '';
	var tel_customer_state = '';
	var tel_customer_zip = '';
	var tel_customer_country = '';
	var tel_customer_pals_number = '';
	var tel_customer_username = '';
	var str = ''; 	
	function  readTealiumCookie(tel_user_info) {	  		  	
		  	str = tel_user_info;	
		  	if (str != null && str != '') {	  	
				var res = str.split("|"); 			
				for(i = 0; i < res.length; i++){
					if (i === 0)tel_customer_firstName =  res[i];
					if (i === 1)tel_customer_lastName =  res[i];
					if (i === 2)tel_customer_email =  res[i];
					if (i === 3)tel_customer_city =  res[i];
					if (i === 4)tel_customer_state =  res[i];
					if (i === 5)tel_customer_zip =  res[i];
					if (i === 6)tel_customer_country =  res[i];
					if (i === 7)tel_customer_pals_number =  res[i];
					if (i === 8)tel_customer_username =  res[i];
				}
			}
	}
	readTealiumCookie(tel_user_info);

	});

var global_data_for_user_reg = {};
var parentGroup_Telium = '{"WC_UserRegistrationUpdateForm_FormInput_firstName_In_Register_1|_|firstName":"customer_name","WC_UserRegistrationUpdateForm_FormInput_lastName_In_Register_1|_|lastName":"customer_name","WC_UserRegistrationUpdateForm_FormInput_logonId_In_Register_1|_|logonId":"customer_email","find-pals-member-num|_|palsRewardsNumber":"customer_pals_number","verify-pals-email|_|email2":"customer_email","new-address-addressLine1|_|address1":"customer_address1","new-address-addressLine2|_|address2":"customer_address2","new-address-city|_|city":"customer_city","new-address-zipCode|_|zipCode":"customer_zip","shipping-address-state|_|state":"customer_state","EMAILPREF_1|_|EMAILPREF_4":"customer_newsletter","EMAILPREF_2|_|EMAILPREF_1":"customer_newsletter","EMAILPREF_3|_|EMAILPREF_2":"customer_newsletter","EMAILPREF_4|_|EMAILPREF_3":"customer_newsletter","PETS_1|_|PETS_11":"customer_pettype","PETS_2|_|PETS_7":"customer_pettype","PETS_3|_|PETS_6":"customer_pettype","PETS_4|_|PETS_12":"customer_pettype","PETS_5|_|PETS_10":"customer_pettype","PETS_6|_|PETS_9":"customer_pettype","PETS_7|_|PETS_8":"customer_pettype","WC_UserRegistrationAddForm_FormInput_firstName_In_Register_1|_|firstName":"customer_name","WC_UserRegistrationAddForm_FormInput_lastName_In_Register_1|_|lastName":"customer_name","WC_UserRegistrationAddForm_FormInput_logonId_In_Register_1|_|logonId":"customer_email","WC_UserRegistrationAddForm_FormInput_Address1_In_Register_1|_|address1":"customer_address1","WC_UserRegistrationAddForm_FormInput_Address2_In_Register_1|_|address2":"customer_address2","WC_UserRegistrationAddForm_FormInput_City_In_Register_1|_|city":"customer_city","WC_UserRegistrationAddForm_FormInput_ZipCode_In_Register_1|_|zipCode":"customer_zip","WC_UserRegistrationAddForm_FormInput_Address2_In_Register_1|_|address2":"customer_address2","WC_UserRegistrationAddForm_FormInput_City_In_Register_1|_|city":"customer_city","WC_UserRegistrationAddForm_FormInput_ZipCode_In_Register_1|_|zipCode":"customer_zip","WC_UserRegistrationAddForm_FormInput_palsRewardsNumber_In_Register_1|_|palsRewardsNumber":"customer_pals_number"}';
var parentGroupJson_telium = JSON.parse(parentGroup_Telium)
$(document).ready(function(){
	var queryStringsArray = location.search.split("&");
	var querystringval = "";
	$(document.emailPreferencesForm).each(function(obj){
			if($("script#dataLayerPageObj").length > 0){
				 $("button",obj).each(function(obj){
						dojo.connect($(this),'click',function(obj){
							readAndFireTeliumTagForReg();
						});
				})
			}
		})
		$('input').each(function(obj){
			if(obj.type != 'hidden'){
				if(typeof(parentGroupJson_telium[obj.id+"|_|"+obj.name]) != "undefined"){
					global_data_for_user_reg[obj.id+"|_|"+obj.name] = obj.value;
				}

							}

				})
		$('select').each(function(obj){
				if(typeof(parentGroupJson_telium[obj.id+"|_|"+obj.name]) != "undefined"){
					global_data_for_user_reg[obj.id+"|_|"+obj.name] = obj.value;
				}
		})
});

